import { render, staticRenderFns } from "./Posession.vue?vue&type=template&id=1b315308&scoped=true&"
import script from "./Posession.vue?vue&type=script&lang=js&"
export * from "./Posession.vue?vue&type=script&lang=js&"
import style0 from "./Posession.vue?vue&type=style&index=0&id=1b315308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b315308",
  null
  
)

export default component.exports